import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import styled from "styled-components";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";

import ConsultingRequestModal from "../modals/ConsultingRequestModal";
import { getBrochureLink } from "../../../services/pagesRequestServices";
import variables from "../../../assets/js/variables";

import imgBrochure from "../../../assets/media/icons/catalogue.png";
import demo from "../../../assets/media/icons/demo.png";
import contact from "../../../assets/media/icons/contact.png";
import { useLocation } from "react-router-dom";

const { colors } = variables;

function SideBox(props) {
  const [isShowRequest, toggleShowRequest] = useState(false);
  const [brochureLink, setBrochureLink] = useState(false);

  const { pathname } = useLocation();
  const id = parseInt(pathname?.split("/news/")[1], 10);
  const getPageTitle = useCallback(() => {
    return getBrochureLink().then((res) => setBrochureLink(res));
  }, []);

  useEffect(() => {
    getPageTitle();
  }, [getPageTitle]);

  if (pathname !== `/news/${id}` && pathname !== `/members`) {
    return (
      <Styles {...props}>
        <ButtonGroup
          orientation="vertical"
          aria-label="vertical contained button group"
          variant="contained"
        >
          <Button key="one" className="btn-container">
            <a href={brochureLink?.document || null}>
              <p>بروشور</p>
              <img src={imgBrochure} alt="" />
            </a>
          </Button>
          {pathname !== "/consulting-request" ? (
            <Button
              key="two"
              onClick={() => toggleShowRequest(true)}
              className="btn-container"
            >
              <p>دمو</p>
              <img src={demo} alt="" />
            </Button>
          ) : null}
          {pathname !== "/contact" ? (
            <Button key="three" className="btn-container">
              <Link to="contact">
                <p>تماس</p>
                <img src={contact} alt="" />
              </Link>
            </Button>
          ) : null}
        </ButtonGroup>
        {isShowRequest && (
          <ConsultingRequestModal
            isOpen={isShowRequest}
            toggleOpen={toggleShowRequest}
            productInfo={{
              title: "",
            }}
          />
        )}
      </Styles>
    );
  } else {
    return null;
  }
}

export default SideBox;

const Styles = styled.div`
  position: fixed;
  top: 50%;
  right: 0px;
  height: 0;
  display: flex;
  align-items: center;
  button {
    font-family: inherit;
    font-size: 18px;
    /* margin: 5px 0; */
    width: 60px;
    height: 60px;
    background: ${colors.text};
    padding: 4px 8px !important;
    font-size: 15px;
    border: none;
    margin-bottom: 2px;
    @media (max-width: 1600px) {
      padding: 7px 16px;
    }
    @media (max-width: 1200px) {
      padding: 5px 10px;
    }
    @media (max-width: 1000px) {
      padding: 7px 14px;
    }
    @media (max-width: 768px) {
      padding: 5px 10px;
    }
    @media (max-width: 500px) {
      padding: 5px 1px;
      width: 20px;
    }
  }

  .btn-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column-reverse;
    opacity: 0.7;
    img {
      width: 30px;
      @media (max-width: 500px) {
        width: 20px !important;
      }
    }
    @media (max-width: 768px) {
      opacity: 0.7;
      max-height: 40px;
    }
    a {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column-reverse;
    }
  }
  p {
    margin: 0;
    @media (max-width: 1000px) {
      display: none !important;
    }
  }

  @media (max-width: 1000px) {
    top: 75%;
  }
  @media (max-width: 788px) {
    top: 70%;
  }

  //**
  .css-etdcgt-MuiButtonBase-root-MuiButton-root {
    :hover {
      /* background: ${colors.green}; */
      background: white;
      opacity: 1;
    }
  }

  .MuiButtonGroup-grouped {
    border: none !important;
  }
  //**
`;
